import * as zod from 'zod';

// Generic 3D vector for positions/sizes (meters)
export const Vector3 = zod.object({
  x: zod.number(),
  y: zod.number(),
  z: zod.number(),
});

// Collision box config stored in equipment config (tip_link frame, meters)
export const CollisionBoxConfig = zod.object({
  origin: Vector3,
  size: Vector3,
});

export type CollisionBoxConfig = zod.infer<typeof CollisionBoxConfig>;
